import { talentAxios } from '@/utils/request';

let Api = {
  getPatentCondition: '/outer-api/global-search/getPatentCondition', // 成果-获取专利搜索条件
  getPaperCondition: '/outer-api/global-search/getPaperCondition', // 成果-获取论文搜索条件
};


// 成果-获取专利搜索条件
export const postPatentConditionApi = (params) => {
  return talentAxios.post(Api.getPatentCondition, params);
};

// 成果-获取论文搜索条件
export const postPaperConditionApi = (params) => {
  return talentAxios.post(Api.getPaperCondition, params);
};



